import isNumberWithExponentialNotation from "../isNumberWithExponentialNotation";

/**
 * Pure price formatter (browser-safe; no React).
 * Mirrors `Price` component formatting used on charts.
 */
export default function formatPrice({
  value,
  currency,
  roundToSecondNumber = false,
  useCommaAsDecimalPointer = false,
  maxDecimalPlace = 4
} = {}) {
  let price = Number(value).toString();

  let trailingZerosCount = price.split(".")[1]
    ? price.split(".")[1].length
    : 0;

  if (!isNumberWithExponentialNotation(price) && trailingZerosCount < 2) {
    if (trailingZerosCount === 0) {
      price += ".";
    }
    for (let i = 0; i < 2 - trailingZerosCount; i++) {
      price += "0";
    }
  }

  let finalPrice = roundToSecondNumber ? Number(price).toFixed(2) : price;

  if (trailingZerosCount > 4 && !roundToSecondNumber) {
    finalPrice = Number(finalPrice).toFixed(maxDecimalPlace);
  }

  if (useCommaAsDecimalPointer) {
    finalPrice = finalPrice.replace(".", ",");
  }

  return `${finalPrice}${currency === "%" ? "" : " "}${
    currency ? currency : ""
  }`.trim();
}
